import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Icon, message, Modal, Spin, Tag, Tooltip } from 'antd';
import { Route, Switch } from "react-router-dom";
import List from '../../components/AssetList';
import Create from './create';
import UploadDocument from './upload';
import Report from './report';
import HistoryReport from './history-report'
import { saveAs } from "file-saver";
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods';

import {
  clearData,
  createResource,
  deleteResource,
  fetchResource,
  findAssetModelBySubType,
  getAllAssetType,
  getResource,
  getResourceForDownload,
  getResourceForQrCodes,
  makeAssetsLeasable,
  saveResourceQuery,
  updateResource,
} from "../../appRedux/actions/Asset";
import {
  clearDataForLabel,
  clearQrScanLogData,
  fetchAssetCodeByModelId,
  fetchAssetHistoryReportData,
  fetchAssetReportData,
  fetchFilter,
  fetchRelationshipSearchData,
  fetchResourceForLabel,
  fetchSubDocumentFilter,
  getEquipmentSubTypeByAssetTypes,
  uploadDocuments,
} from '../../appRedux/actions';
import { createResource as qrScanLog } from '../../appRedux/actions/QrScanLog';
import AccessControl from "../../components/AccessControl";
import QRCode from 'qrcode';
import * as _ from 'lodash';
import Status from "../Leasing/status";
import LatestImage from "./latest-image";
import QrRedirect from "./qr_redirect";

export class Asset extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {
      status: '{"value":[["ASSIGNED","IDLE","INTRANSIT","CLOSED","ISSUED"]],"type":"String","field":"status"}'
    },
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
    labelQrCode: null,
    labelModalVisible: false,
    qrCodeUrl: '',
    assetCodeForModal: '',
    qrCodeurlForList: [],
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.clearLabelData();
    this.props.fetchFilter(this.props.resourceName);
    this.props.fetchSubDocumentFilter('Document');
    this.props.getAllAssetType();
  }

  /*getQRCodes = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForQrCodes(JSON.stringify(columns), this.props.filters, this.state.columns, "Asset");
  }*/

  componentWillUnmount() {
    this.clearLabelData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const filters = nextProps.filters;

      filters.assetType = {
        field: "assetType",
        type: "ObjectID",
        options: { ref: "AssetType", required: true, main: "name" },
        required: true,
        data: {
          data: [],
          count: 0,
        },
      };

      const columns = Object.keys(filters).filter((filter) => Boolean(filters[filter].options && filters[filter].options.column));
      // const defaultCol = ['equipmentSubType', 'location', 'client', 'altName', 'description', 'assetType', 'parent', 'latestAta','saleVendor'];
      const defaultCol = ['isCountable', 'assetModel', 'equipmentSubType', 'latestCondition', 'location', 'client', 'altName', 'parent', 'vendor', 'qrLinked'];
      this.setState({
        visibleColumns: [...defaultCol, ...columns]
      }, () => {
        this.renderColumns(filters, this.state.visibleColumns);
      })
    }
    // not an empty object
    if (nextProps.labelData && Object.keys(nextProps.labelData).length > 0) {
      this.renderLabel(nextProps.labelData);
    }

    // if (nextProps.data !== this.props.data){
    //   const finalData =[];
    //   const dataForQr = nextProps.data;
    //   dataForQr && dataForQr.map(async(item)=> {
    //     item['qrCodeUrlData']= await this.openQrCode(item);
    //     finalData.push(item);
    //   });
    //   this.setState({qrCodeurlForList:finalData})
    // }

    // console.log(nextProps.data)
  }

  openQrCode = async (record) => {
    const data = {
      "field": "assetCode",
      "type": "String",
      "options": {
        "required": true,
        "column": true
      },
      "required": true
    }
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: [[`${record.assetCode}`]],
      type: 'String',
      field: 'assetCode'
    });
    this.props.saveResourceQuery(query);
    let dataForQr = [], labelQrCode = '', newDataUri = '', str = '';
    let bfr;
    dataForQr = await this.props.getResourceForQrCodes();
    for (let i = 0; i < (dataForQr && dataForQr.length); i++) {
      const newUrl = `${window.location.origin}/asset/qr-code?organizationId=${dataForQr[i].organisation}&assetCode=${dataForQr[i].assetCode}`;
      labelQrCode = await QRCode.toDataURL(newUrl);
      newDataUri = await this.resizedataURL(labelQrCode, 300, 300);
      str = await newDataUri.substring(newDataUri.indexOf(',') + 1);
      bfr = 'data:image/jpeg;base64,' + str.toString('base64');
    }
    return bfr;
  }

  handleColumnChange = (value, array) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {
        status: '{"value":[["ASSIGNED","IDLE","INTRANSIT","CLOSED","ISSUED"]],"type":"String","field":"status"}'
      },
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
    window.location.reload(false);
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;
    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  getLatestImage = (assetId) => {
    // console.log(this.state.status)
    return <LatestImage id={assetId} />
  }

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    // console.log(filters['purchaseVendor'], resourceName);
    columns.push({
      title: 'Photo',
      dataIndex: 'photo',
      key: 'photo',
      render: (_, record) => this.getLatestImage(record._id),
      width: 100,
    });

    if (selectedColumns.indexOf('assetCode') >= 0) {
      columns.push({
        title: sanitizeFieldName('assetCode'),
        dataIndex: filters['assetCode'].field,
        key: filters['assetCode'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['assetCode'].type),
        ...getColumnSearchProps(filters['assetCode'], this.handleFilter, this.handleReset, resourceName)
      });
    }

    if (selectedColumns.indexOf('isCountable') >= 0) {
      columns.push({
        title: 'Is Countable',
        dataIndex: 'isCountable',
        key: 'isCountable',
        render: (_, record) => (record && record.assetModel && record.assetModel && record.assetModel.isCountable) ?
          <Tooltip title="True"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone"
            twoToneColor="#52c41a" /></Tooltip> :
          <Tooltip title="False"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }}
            twoToneColor="#eb2f96" /></Tooltip>,
        ...getColumnSearchProps(filters['isCountable'], this.handleFilter, this.handleReset, resourceName)
      });
    }

    // if (selectedColumns.indexOf('latestCondition') >= 0) {
    //     columns.push({
    //         title: 'latestCondition',
    //         dataIndex: 'latestCondition',
    //         key: 'latestCondition',
    //         render: (_, record) => record && record.latestCondition || '-',
    //         ...getColumnSearchProps(filters['latestCondition'], this.handleFilter, this.handleReset, resourceName)
    //     });
    // }

    if (selectedColumns.indexOf('assetModel') >= 0) {
      columns.push({
        title: sanitizeFieldName('assetModel'),
        dataIndex: 'assetModel',
        key: 'assetModel',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['assetModel'].type),
        ...getColumnSearchProps(filters['assetModel'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    if (selectedColumns.indexOf('equipmentSubType') >= 0) {
      columns.push({
        title: sanitizeFieldName('assetSubType'),
        dataIndex: filters['equipmentSubType'].field,
        key: filters['equipmentSubType'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['equipmentSubType'].type),
        ...getColumnSearchProps(filters['equipmentSubType'], this.handleFilter, this.handleReset, resourceName)
      })
    }
    if (selectedColumns.indexOf('assetType') >= 0) {
      columns.push({
        title: sanitizeFieldName('assetType'),
        dataIndex: 'equipmentSubType.assetType',
        key: 'assetType',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['assetType'].type),
        ...getColumnSearchProps(filters['assetType'], this.handleFilter, this.handleReset, resourceName)
      })
    }
    if (selectedColumns.indexOf('location') >= 0) {
      columns.push({
        title: sanitizeFieldName('location'),
        dataIndex: filters['location'].field,
        key: filters['location'].field,
        sorter: true,
        render: (value, ...data) => {
          let location = data && data[0] && data[0].status;
          // return getRenderForFieldByType(value || location, filters['location'].type)
          return getRenderForFieldByType(value, filters['location'].type)
        },
        ...getColumnSearchProps(filters['location'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    if (selectedColumns.indexOf('client') >= 0) {
      columns.push({
        title: sanitizeFieldName('subLocation'),
        dataIndex: filters['client'].field,
        key: filters['client'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['client'].type),
        ...getColumnSearchProps(filters['client'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    if (selectedColumns.indexOf('owner') >= 0) {
      columns.push({
        title: sanitizeFieldName('owner'),
        dataIndex: filters['owner'].field,
        key: filters['owner'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['owner'].type),
        ...getColumnSearchProps(filters['owner'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    if (selectedColumns.indexOf('invoiceValue') >= 0) {
      columns.push({
        title: sanitizeFieldName('invoiceValue'),
        dataIndex: 'invoiceValue',
        key: 'invoiceValue',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'Number', 'invoiceValue'),
      });
    }

    if (selectedColumns.indexOf('altName') >= 0) {
      columns.push({
        title: sanitizeFieldName('altName'),
        dataIndex: filters['altName'].field,
        key: filters['altName'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['altName'].type),
        ...getColumnSearchProps(filters['altName'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    if (selectedColumns.indexOf('parent') >= 0) {
      columns.push({
        title: 'Asset Linked (Parent)',
        dataIndex: filters['parent'].field,
        key: filters['parent'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['parent'].type),
        ...getColumnSearchProps(filters['parent'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    Object.keys(filters).forEach((item) => {
      if (item === '_id' || item === 'assetModel') {
        return;
      }
      if (selectedColumns.indexOf(item) === -1
        || item === 'parent' || item === 'description' || item === 'invoiceValue' || item === 'altName' || item === 'owner' || item === 'client' || item === 'location' || item === 'assetType' || item === 'equipmentSubType' || item === 'assetCode' || item === 'custodian') {
        return;
      }
      if (item === 'employeeId') {
        return columns.push({
          title: sanitizeFieldName(filters[item].options.label),
          dataIndex: filters[item].field,
          sorter: true,
          render: (value) => getRenderForFieldByType(value, filters[item].type),
          ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
        });
      }
      if (item !== 'isCountable' && item !== 'qrLinked' && item !== 'latestCondition') {
        // console.log(item)
        columns.push({
          title: sanitizeFieldName(item),
          dataIndex: filters[item].field,
          sorter: true,
          render: (value) => getRenderForFieldByType(value, filters[item].type, item),
          ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
        });
      }
    });

    if (selectedColumns.indexOf('description') >= 0) {
      columns.push({
        title: sanitizeFieldName('description'),
        dataIndex: filters['description'].field,
        key: filters['description'].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters['description'].type),
        ...getColumnSearchProps(filters['description'], this.handleFilter, this.handleReset, resourceName)
      })
    }

    if (selectedColumns.indexOf('latestAta') >= 0) {
      columns.push({
        title: 'Last Ata',
        dataIndex: 'latestAta',
        key: 'latestAta',
        sorter: true,
        render: (value) => getRenderForFieldByType(value, 'String'),
      });
    }

    if (selectedColumns.indexOf('latestCondition') >= 0) {
      columns.push({
        title: 'Latest Condition',
        dataIndex: 'latestCondition',
        key: 'latestCondition',
        render: (_, record) => record && record.latestCondition || '',
        // ...getColumnSearchProps(filters['latestCondition'], this.handleFilter, this.handleReset, resourceName)
      });
    }

    if (selectedColumns.indexOf('qrLinked') >= 0) {
      columns.push({
        title: 'Qr Linked',
        dataIndex: 'qrLinked',
        key: 'qrLinked',
        render: (_, record) => record && record.qrLinked,
        ...getColumnSearchProps(filters['qrLinked'], this.handleFilter, this.handleReset, resourceName)
      });
    }

    // columns.push({
    //   title: 'QRCode',
    //   key: 'action',
    //   render: (record) => (
    //     <div>
    //       <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
    //                      roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
    //         return <Button
    //           className='button-for-job-card'
    //           style={{marginLeft: '10px'}}
    //           type="default"
    //           size='small'
    //           onClick={() => this.openQrCode(record)}>View QR Code</Button
    //         >;
    //       }}/>
    //
    //     </div>
    //   ),
    // });

    // columns.push({
    //   title: 'QR Code Linked',
    //   dataIndex: 'qrCodeUrlData',
    //   key: 'qrCodeUrlData',
    //   render: (record) => record && (
    //     <div>
    //       <img src={record} alt='qrcode' width={100} height={100}/>
    //     </div>
    //   ),
    // });

    // columns.push({
    //   title: 'QR Linked',
    //   dataIndex: 'qrCodeNewUrlData',
    //   key: 'qrCodeNewUrlData',
    //   render: (record) => record ? 'Yes' : 'No'
    // });


    // if (selectedColumns.indexOf('qrLinked') >= 0) {
    //     columns.push({
    //         title: 'QR Linked',
    //         dataIndex: 'qrLinked',
    //         key: 'qrLinked',
    //         // render: (record) => record ? 'Yes' : 'No'
    //     });
    // }

    if (selectedColumns.indexOf('vendor') >= 0) {
      columns.push({
        title: 'Purchase Vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        render: (record) => {
          return record
        },
        // ...getColumnSearchProps(filters['purchaseVendor'], this.handleFilter, this.handleReset, resourceName)
      });
    }

    if (selectedColumns.indexOf('saleVendor') >= 0) {
      columns.push({
        title: 'Sale Vendor',
        dataIndex: 'saleVendor',
        key: 'saleVendor',
        render: (record) => {
          return record
        },
        // ...getColumnSearchProps(filters['purchaseVendor'], this.handleFilter, this.handleReset, resourceName)
      });
    }

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Edit</Button>
            }} />

          {/*<AccessControl resource={this.props.resourceName} permissionNeeded={'d'}*/}
          {/*               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {*/}
          {/*  return <Popconfirm*/}
          {/*    title="Are you sure you want to delete this record?"*/}
          {/*    onConfirm={() => {*/}
          {/*      this.deleteResource(record._id)*/}
          {/*    }}*/}
          {/*    onCancel={this.cancelDelete}*/}
          {/*    okText="Yes"*/}
          {/*    cancelText="No"*/}
          {/*  >*/}
          {/*    <Button */}
          {/*      style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>*/}
          {/*  </Popconfirm>*/}
          {/*}}/>*/}

          <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button style={{ marginLeft: '10px' }} type="primary" size='small'
                onClick={() => this.historyReport(record._id)}>Report</Button>;
            }} />

          {/*<AccessControl resource={this.props.resourceName} permissionNeeded={'r'}*/}
          {/*               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {*/}
          {/*  return <Button style={{marginLeft: '10px'}} type="default" size='small'*/}
          {/*                 onClick={() => this.printLabel(record._id)}>Print Label</Button>;*/}
          {/*}}/>*/}

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  fetchList = () => {
    this.clearLabelData();
    this.props.getResource();
  };

  createResource = (values) => {
    const data = Object.assign({}, values);
    if (!data.parent) {
      delete data.parent
    }
    data.documents = data.documents || [];
    this.props.createResource(data);
  };

  updateResource = (values, id) => {
    const data = Object.assign({}, values);
    if (!data.parent) {
      delete data.parent
    }
    data.documents = values.documents || [];
    this.props.updateResource(data, id);
  };

  uploadDocuments = (values, id) => {
    const data = Object.assign({}, values);
    data.documents = values.documents || [];
    this.props.uploadDocuments(data, id);
  };

  deleteResource = (id) => {
    this.clearLabelData();
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    this.clearLabelData();
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  upload = () => {
    this.clearLabelData();
    const { match } = this.props;
    this.props.history.push(`${match.url}/upload`);
  };

  makeLeasable = (data, filterMasterData) => {
    const { filters } = { ...this.props.query }
    const assetTypes = this.props.assetTypes;

    let content = [];
    let reqFilter = {};
    for (const property in filters) {
      const obj = JSON.parse(filters[property]);
      if (obj['value']) {
        //let data = {};
        const flatPropertyValue = [].concat.apply([], obj['value']);
        //data[property] = flatPropertyValue;
        let field = property;
        if (property === 'equipmentSubType')
          field = 'AssetSubType';
        if (obj['type'] === 'ObjectID') {
          const propertyMaster = filterMasterData[property];
          let propertyData = [];
          if (field === 'assetType')
            propertyData = assetTypes;
          else
            propertyData = propertyMaster.data && propertyMaster.data.data ? propertyMaster.data.data : [];
          const filteredProperty = propertyData.filter(item => flatPropertyValue.includes(item._id.toString()));
          content.push(<div key={field}><Tag color='magenta'>{sanitizeFieldName(field)}</Tag> : <Tag
            color='cyan'>{filteredProperty.map(doc => doc.name).join()}</Tag></div>);
        } else {
          content.push(<div key={field}><Tag color='magenta'>{sanitizeFieldName(field)}</Tag> : <Tag
            color='cyan'>{obj['value'].join()}</Tag></div>);
        }
        reqFilter[property] = flatPropertyValue;
      }
    }
    this.confirm(content, reqFilter);
  }

  confirm = (content, data) => {
    let style = { color: 'black' };
    const sureStyle = { color: 'tomato' };
    if (!content || content.length === 0) {
      content.push(<div><h3 style={{ color: 'tomato' }}>No filter found, this will apply to all assets.</h3></div>);
    }
    content.push(<div><h4 style={{ color: 'tomato' }}>All assets with above criteria will be leasable. Are you sure
      ?</h4>
    </div>);
    Modal.confirm({
      title: 'Confirm apply filter to change assets to leasable ?',
      content: <div>{
        content.map(item => item)
      }</div>,
      okText: 'Yes I\'m sure',
      cancelText: 'Cancel',
      width: '55%',
      confirmLoading: true,
      onOk: () => {
        this.props.makeAssetsLeasable(data);   //leasableCount
      }
    });
  }

  edit = (id) => {
    this.clearLabelData();
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  report = () => {
    this.clearLabelData();
    const { match } = this.props;
    this.props.history.push(`${match.url}/report`);
  };

  historyReport = (id) => {
    this.clearLabelData();
    const { match } = this.props;
    this.props.history.push(`${match.url}/history-report/${id}`);
  };

  linkHandler = (_id, page, route) => {
    this.props.history.push(`/${page}/${route}/${_id}`);
    route === 'history-report' && window.location.reload();
  };

  handleLabelOk = () => {
    const innerContainerStyles = `
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
      `;

    const bodyStyles = `
      html, body {
        padding: 0;
        margin: 0;
      }

      @media print {
        html, body {
          height: 288px;
          width: 408px;
        }
      }
    `;

    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=800,toolbar=0,scrollbars=0,status=0,resizable=0');
    if (WinPrint.document.styleSheets.length === 0) {
      const head = WinPrint.document.head;
      const style = WinPrint.document.createElement("style");
      style.innerHTML = bodyStyles;
      head.appendChild(style);
    }
    WinPrint.document.body.innerHTML = window.document.getElementById("printable-content").innerHTML;
    WinPrint.document.getElementById("printable-content-inner").setAttribute('style', innerContainerStyles);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();

    this.clearLabelData();
  };

  handleLabelCancel = () => {
    this.clearLabelData();
  };

  clearLabelData = () => {
    if (this.state.labelModalVisible) {
      this.setState({
        labelModalVisible: false,
      });
    }
    if (this.state.labelQrCode) {
      this.setState({
        labelQrCode: null,
      });
    }
    this.props.clearDataForLabel();
  };

  printLabel = (labelId) => {
    this.clearLabelData();
    this.props.fetchResourceForLabel(labelId);
  };

  renderLabel = async (labelData) => {
    let url = `${window.location.origin}/asset/qr-code?organizationId=${labelData.organisation}&assetCode=${labelData.assetCode}`;

    const scannerData = labelData.scannerData || [];
    const qrData = scannerData.filter(scanner => scanner.type === 'QR')
    if (qrData && qrData.length) {
      url = `https://qrcode.theassetpro.com/api/qr/${qrData[0]['id']}`;
    }

    //const url = `${window.location.origin}/asset/history-report/${labelData._id}?assetCode=${labelData.assetCode}`;
    const labelQrCode = await QRCode.toDataURL(url);
    this.setState({
      labelQrCode,
      labelModalVisible: true,
    })
  };

  downloadToCSV = () => {
    const columns = [];
    // Map column titles to their dataIndex for proper export
    this.state.columns.forEach(column => {
      if (column.title !== "Action" && column.title !== "Photo") {
        // Use dataIndex if available, otherwise use camelCased title
        const fieldName = column.dataIndex || _.camelCase(column.title);
        if (!columns.includes(fieldName)) {
          columns.push(fieldName);
        }
      }
    });
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, this.state.columns, "Asset");
  }

  downloadQrCodes = async () => {
    let data = [], labelQrCode = '', newDataUri = '', str = '';
    let zip = require('jszip')();
    data = await this.props.getResourceForQrCodes();
    for (let i = 0; i < (data && data.length); i++) {
      //const url = `${window.location.origin}/asset/history-report/${data[i]._id}?assetCode=${data[i].assetCode}`;
      const newUrl = `${window.location.origin}/asset/qr-code?organizationId=${data[i].organisation}&assetCode=${data[i].assetCode}`;
      labelQrCode = await QRCode.toDataURL(newUrl);
      newDataUri = await this.resizedataURL(labelQrCode, 300, 300);
      str = newDataUri.substring(newDataUri.indexOf(',') + 1);
      zip.file(`${data[i].assetCode}.png`, str, { base64: true });
      /*fetch(labelQrCode, {
        method: "GET",
        headers: {}
      }).then(response => {
        console.log(response);
        response.arrayBuffer().then(function(buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${data[i].assetCode}.png`); //or any other extension
          document.body.appendChild(link);
          console.log('link is', link)
          console.log('link download', link.download);
          fileArray.push(link.download);
          zip.file(`${data[i].assetCode}`,link.download);
        });
      })
        .catch(err => {
          console.log(err);
        });*/
    }
    await zip.generateAsync({ type: "blob" }).then(function (content) {
      // see FileSaver.js
      saveAs(content, "assetQrCodes.zip");
    });
  }

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  resizedataURL = (datas, wantedWidth, wantedHeight) => {
    return new Promise(async function (resolve, reject) {

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function () {
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        var dataURI = canvas.toDataURL();

        // This is the return of the Promise
        resolve(dataURI);
      };

      // We put the Data URI in the image's src attribute
      img.src = datas;

    })
  }

  updateDocument = (values, id) => {
    const payload = {
      file: (values.files.file && values.files.file) || {},
      name: values.name,
      type: values.type,
      amount: values.amount,
      renewalDate: values.renewalDate,
      documentDate: values.documentDate,
    };
    this.props.updateDocument(payload, id);
  };

  deleteDocument = (id) => {
    this.props.deleteDocument(id);
  };

  render() {
    const {
      match,
      data,
      resource,
      edit,
      fetchResource,
      loading: commonLoading,
      dataLoading,
      filters,
      modules,
      authUser,
      resourceName,
      searchData,
      fetchAssetCodeByModelId,
      fetchRelationshipSearchData,
      assetCode,
      getAllAssetType,
      assetTypes,
      equipmentSubTypes,
      getEquipmentSubTypeByAssetTypes,
      fetchAssetReportData,
      reports,
      fetchAssetHistoryReportData,
      historyReport,
      labelData,
      qrScanLogSuccess,
      downloadProgress,
      downloadProgressForExcel
    } = this.props;
    const { columns, visibleColumns, labelModalVisible, labelQrCode } = this.state;
    faviconDynamicFunction(authUser);

    // console.log(columns);
    // console.log(data);
    const loading = commonLoading || dataLoading;
    return (<div>
      {/* <h2>{resourceName}</h2> */}

      {/*<Modal title="Label Printer"*/}
      {/*       okText="Print Label"*/}
      {/*       okType="primary"*/}
      {/*       centered={true}*/}
      {/*       visible={labelModalVisible}*/}
      {/*       onOk={this.handleLabelOk}*/}
      {/*       onCancel={this.handleLabelCancel}*/}
      {/*>*/}
      {/*    {Object.keys(labelData).length !== 0*/}
      {/*        ? <div id="printable-content">*/}
      {/*            <div id="printable-content-inner" className="labelContainer">*/}
      {/*                <img src={labelQrCode || ""} alt="QR Code"/>*/}
      {/*                <div>*/}
      {/*                    <p><strong>Asset Code: </strong>*/}
      {/*                        {(labelData && labelData.assetCode) || "None"}*/}
      {/*                    </p>*/}
      {/*                </div>*/}
      {/*            </div>*/}
      {/*        </div>*/}
      {/*        : <Spin spinning={loading}/>}*/}
      {/*</Modal>*/}

      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            title={resourceName}
            seeReport={this.report}
            size={'middle'}
            create={this.create}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
            upload={this.upload}
            makeLeasable={() => this.makeLeasable(data, filters)}
            visibleColumn={visibleColumns}
            downloadToCSV={this.downloadToCSV}
            downloadQrCodes={this.downloadQrCodes}
            downloadProgress={downloadProgress}
            downloadProgressForExcel={downloadProgressForExcel}
          />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create data={{}}
            filters={filters}
            subDocumentFilters={this.props.subDocumentFilters}
            modules={modules}
            title={'CREATE'}
            findAssetModelBySubType={this.props.findAssetModelBySubType}
            assetModel={this.props.assetModel}
            resource={resourceName}
            onChange={this.handleFormChange}
            onSubmit={this.createResource}
            fetchAssetCodeByModelId={fetchAssetCodeByModelId}
            assetCode={assetCode}
            loading={loading}
            {...props}
          />
          } />
        <Route path={`${match.url}/upload/:asset?`}
          render={(props) => <UploadDocument data={edit}
            filters={filters}
            subDocumentFilters={this.props.subDocumentFilters}
            modules={modules}
            title={'CREATE'}
            searchData={searchData}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onSubmit={this.uploadDocuments}
            clearData={this.props.clearData}
            loading={loading}
            fetchRelationshipSearchData={fetchRelationshipSearchData}
            {...props}
          />
          } />
        <Route path={`${match.url}/report`}
          render={(props) => <Report data={{}}
            filters={filters}
            subDocumentFilters={this.props.subDocumentFilters}
            getAllAssetType={getAllAssetType}
            assetTypes={assetTypes}
            modules={modules}
            title={'REPORT'}
            resource={resourceName}
            onChange={this.handleFormChange}
            onSubmit={this.createResource}
            fetchAssetCodeByModelId={fetchAssetCodeByModelId}
            getEquipmentSubTypeByAssetTypes={getEquipmentSubTypeByAssetTypes}
            fetchAssetReportData={fetchAssetReportData}
            equipmentSubTypes={equipmentSubTypes}
            reports={reports}
            assetCode={assetCode}
            loading={loading}
            {...props}
          />
          } />
        <Route path={`${match.url}/history-report/:id`}
          render={(props) => <HistoryReport data={historyReport}
            filters={filters}
            modules={modules}
            title={'ASSET HISTORY REPORT'}
            resource={resourceName}
            fetch={fetchAssetHistoryReportData}
            linkHandler={this.linkHandler}
            qrScanLog={this.props.qrScanLog}
            qrScanLogSuccess={qrScanLogSuccess}
            clearQrScanLogData={this.props.clearQrScanLogData}
            loading={loading}
            authUser={authUser}
            {...props}
          />
          } />

        <Route path={`${match.url}/qr-code`}
          render={(props) =>
            <QrRedirect {...props} />
          } />

        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={edit}
            filters={filters}
            modules={modules}
            title={'EDIT'}
            resource={resourceName}
            fetch={fetchResource}
            findAssetModelBySubType={this.props.findAssetModelBySubType}
            assetModel={this.props.assetModel}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            loading={loading}
            {...props}
          />
          } />
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({ auth, asset, qrScanLog, commonData }) => {
  return {
    authUser: auth.authUser,
    total: asset.total,
    data: asset.resources,
    resource: asset.resource,
    assetModel: asset.assetModel,
    edit: asset.edit,
    query: asset.query,
    loading: commonData.loading,
    dataLoading: commonData.dataLoading,
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters,
    assetCode: asset.assetCode,
    assetTypes: asset.assetTypes,
    equipmentSubTypes: asset.equipmentSubTypes,
    reports: asset.reports,
    historyReport: asset.historyReport,
    searchData: commonData.relationshipSearch,
    downloadProgress: commonData.download,
    labelData: asset.labelData,
    qrScanLogSuccess: qrScanLog.success,
    leasableCount: asset.leasable,
    downloadProgressForExcel: commonData.downloadProgressForExcel,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    getResourceForQrCodes,
    createResource,
    fetchResource,
    fetchResourceForLabel,
    updateResource,
    uploadDocuments,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    fetchSubDocumentFilter,
    findAssetModelBySubType,
    fetchAssetCodeByModelId,
    getAllAssetType,
    getEquipmentSubTypeByAssetTypes,
    fetchAssetReportData,
    fetchAssetHistoryReportData,
    fetchRelationshipSearchData,
    clearData,
    clearDataForLabel,
    qrScanLog,
    clearQrScanLogData,
    makeAssetsLeasable,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(Asset);
